import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity } from 'lucide-react';
import { useMobileMenu } from './MobileMenuContext';
import { useDashboardStats } from '@/hooks/useDashboardStats';

const MobileDashboardButton = () => {
  const navigate = useNavigate();
  const { closeMenu } = useMobileMenu();
  const { totalPending } = useDashboardStats();

  const handleNavigation = () => {
    try {
      navigate('/dashboard');
    } catch (error) {
      console.error('Navigation failed:', error);
    } finally {
      closeMenu();
    }
  };

  return (
    <button
      onClick={handleNavigation}
      className="flex items-center justify-between w-full p-4 rounded-lg bg-primary/5 hover:bg-primary/10 border border-primary/20 transition-colors relative"
    >
      <div className="flex items-center gap-3">
        <Activity className="h-5 w-5 text-primary" />
        <span className="font-semibold text-primary">My Activity</span>
      </div>
      {totalPending > 0 && (
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white ring-2 ring-white">
          {totalPending > 9 ? '9+' : totalPending}
        </span>
      )}
    </button>
  );
};

export default MobileDashboardButton;
